import PolicyPage from '../components/PolicyPage';

const WinnerPackageTermsPage = () => {
  return (
    <PolicyPage 
      title="Winner Package Terms and Conditions"
      metaTitle="Winner Package Terms and Conditions - Award Winner Benefits"
      metaDescription="Understand the winner package terms for Golden Tree Events awards. Covers package inclusions, trophy details, media coverage, ceremony guidelines, and winner obligations."
      sourceUrl="https://gtedubai.com/app/winner-package-terms-and-conditions?awd=gte"
    />
  );
};

export default WinnerPackageTermsPage;
